module.exports = __webpack_public_path__ + "img/politics.8a7f0d27.svg";